import { Box, Button, Card, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { usePackFeatures } from 'src/contexts/PackFeaturesContext';

// Page d'une fonctionnalité absente du pack de l'entreprise (lien direct, favori) : un
// message à la place de la page, qui sinon recevrait des 403 PACK_FEATURE_MISSING.
// Seul l'admin peut changer de pack, sur le site guest.
function RequireFeature({ feature, children }) {
  const { t } = useTranslation();
  const { hasFeature, loaded } = usePackFeatures();
  const role = useSelector((x) => x.user.role);

  // Pack pas encore connu : on attend, sinon la page lancerait ses requêtes (403 hors pack).
  if (!loaded) return null;
  if (hasFeature(feature)) return children;

  return (
    <Box display="flex" justifyContent="center" alignItems="center" sx={{ minHeight: '60vh', p: 3 }}>
      <Card sx={{ maxWidth: 460, p: 4, textAlign: 'center' }}>
        <LockOutlinedIcon sx={{ fontSize: 48, color: '#18E68E', mb: 1 }} />
        <Typography variant="h4" gutterBottom>
          {t('pack_feature.title')}
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          {role === 'ADMIN' ? t('pack_feature.text_admin') : t('pack_feature.text_member')}
        </Typography>
        {role === 'ADMIN' && (
          <Button
            variant="contained"
            href={`${process.env.REACT_APP_ADMIN_URL}/abonnements`}
            sx={{ background: '#18E68E', color: '#000', '&:hover': { background: '#14c97b' } }}
          >
            {t('pack_feature.see_plans')}
          </Button>
        )}
      </Card>
    </Box>
  );
}

export default RequireFeature;
